/**
 * 初期表示用のプログレスバー（メッセージ＋進捗率）を管理します
 *
 * 母数（total）を指定して開始し、処理が1つ完了するたびに advanceProgress を呼びます。
 */
"use strict";
let progressTotal = 0;
let progressDone = 0;
function ensureOverlay() {
    let overlay = document.getElementById('progressOverlay');
    if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'progressOverlay';
        overlay.innerHTML =
            '<div class="progress-box">' +
                '<div class="progress-message"></div>' +
                '<div class="progress-track"><div class="progress-bar"></div></div>' +
                '<div class="progress-percent"></div>' +
                '</div>';
        document.body.appendChild(overlay);
    }
    return overlay;
}
function render(message) {
    const overlay = ensureOverlay();
    const percent = progressTotal > 0 ? Math.round((progressDone / progressTotal) * 100) : 0;
    overlay.querySelector('.progress-message').textContent = message;
    overlay.querySelector('.progress-bar').style.width = `${percent}%`;
    overlay.querySelector('.progress-percent').textContent = `${percent}%`;
}
/** プログレスバーを表示する（進捗0%） */
export const startProgressDisplay = (total, message) => {
    progressTotal = total;
    progressDone = 0;
    render(message);
    ensureOverlay().style.display = 'flex';
};
/** 実行中の処理のメッセージを更新する（進捗は変えない） */
export const setProgressMessage = (message) => {
    render(message);
};
/** 処理が1つ完了したものとして進捗を進め、次の処理のメッセージを表示する */
export const advanceProgress = (nextMessage) => {
    progressDone = Math.min(progressTotal, progressDone + 1);
    render(nextMessage);
};
/** プログレスバーを非表示にする */
export const endProgressDisplay = () => {
    const overlay = document.getElementById('progressOverlay');
    if (overlay)
        overlay.style.display = 'none';
};
